import { render, staticRenderFns } from "./LineFab.vue?vue&type=template&id=28a578c6&lang=pug&"
import script from "./LineFab.vue?vue&type=script&lang=js&"
export * from "./LineFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LineFab.vue"
export default component.exports